import React, { isValidElement, cloneElement, Component } from 'react';
import classNames from 'classnames';
import omit from 'lodash/omit';
import toArray from 'lodash/toArray';
import isArray from 'lodash/isArray';
import animation from '../_util/openAnimation';
import CollapsePanel from './CollapsePanel';
import RcCollapse from '../rc-components/collapse';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import defaultLocale from '../locale-provider/default';
import ConfigContext from '../config-provider/ConfigContext';
export default class Collapse extends Component {
    constructor() {
        super(...arguments);
        this.renderExpandTextContent = (panelProps = {}, locale, localeCode, expandIconPositionCof) => {
            const { prefixCls: customizePrefixCls, } = this.props;
            const { getPrefixCls } = this.context;
            const prefixCls = getPrefixCls('collapse', customizePrefixCls);
            const iconCls = classNames({
                [`${prefixCls}-expand-icon`]: true,
                [`${prefixCls}-expanded`]: panelProps.isActive,
                [`${prefixCls}-collapsed`]: !panelProps.isActive,
            });
            const icon = React.createElement("i", { className: iconCls });
            return (React.createElement(React.Fragment, null,
                expandIconPositionCof === 'left' && icon,
                panelProps.isActive ? React.createElement("span", { className: `${prefixCls}-expand-text`, style: { minWidth: localeCode === 'zh-cn' ? '0.38rem' : '0.52rem' } }, locale.fold) :
                    React.createElement("span", { className: `${prefixCls}-expand-text`, style: { minWidth: localeCode === 'zh-cn' ? '0.38rem' : '0.52rem' } }, locale.unfold),
                expandIconPositionCof === 'right' && icon));
        };
        this.renderItems = () => {
            const { children, collapsible: parentCollapsible } = this.props;
            let arrayChildren = children;
            if (!isArray(children)) {
                arrayChildren = [children];
            }
            return toArray(arrayChildren).map((child, index) => {
                if (isValidElement(child)) {
                    const key = child.key || String(index);
                    const { disabled, collapsible } = child.props;
                    if (disabled) {
                        const childProps = {
                            ...omit(child.props, 'disabled'),
                            key,
                            disabled: collapsible && (collapsible === 'header' || collapsible === 'icon') ? false : disabled,
                        };
                        return cloneElement(child, childProps);
                    }
                    return cloneElement(child, { ...child.props, key, disabled: collapsible ? collapsible === 'disabled' : parentCollapsible === 'disabled' });
                }
                return child;
            });
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    render() {
        const { prefixCls: customizePrefixCls, className = '', expandIcon, bordered, expandIconPosition, trigger, ghost, } = this.props;
        const { getPrefixCls, getConfig } = this.context;
        const prefixCls = getPrefixCls('collapse', customizePrefixCls);
        const expandIconPositionCof = expandIconPosition || getConfig('collapseExpandIconPosition');
        const expandIconCof = expandIcon || getConfig('collapseExpandIcon');
        const triggerCof = trigger || getConfig('collapseTrigger');
        const collapseClassName = classNames({
            [`${prefixCls}-borderless`]: !bordered,
            [`${prefixCls}-text-action`]: expandIconCof === 'text' && expandIconPositionCof === 'left',
            [`${prefixCls}-trigger`]: triggerCof === 'header',
            [`${prefixCls}-ghost`]: ghost,
            [`${prefixCls}-icon-position-${expandIconPositionCof}`]: true,
        }, className);
        let expandIconContent;
        if (typeof expandIconCof === 'function') {
            expandIconContent = (panelProps) => expandIconCof(panelProps);
        }
        else if (expandIconCof === 'text') {
            expandIconContent = (panelProps) => {
                return (React.createElement(LocaleReceiver, { componentName: "Collapse", defaultLocale: defaultLocale.Collapse }, (locale, localeCode) => this.renderExpandTextContent(panelProps, locale, localeCode, expandIconPositionCof)));
            };
        }
        return (React.createElement(RcCollapse, Object.assign({}, this.props, { expandIcon: expandIconContent, expandIconPosition: expandIconPositionCof, prefixCls: prefixCls, className: collapseClassName }), this.renderItems()));
    }
}
Collapse.displayName = 'Collapse';
Collapse.Panel = CollapsePanel;
Collapse.defaultProps = {
    bordered: true,
    openAnimation: {
        ...animation,
        appear() { },
    },
};
